import { render, staticRenderFns } from "./DniField.vue?vue&type=template&id=14940512&"
import script from "./DniField.vue?vue&type=script&lang=ts&"
export * from "./DniField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports